<template>
  <p
    v-if="offerWithFlashOffer && offerWithFlashOffer.endDate"
    class="text-static-default-hi body-2 pb-16"
  >
    {{
      i18n(translations.expirationDateLabel, {
        endDate: new Date(offerWithFlashOffer.endDate),
      })
    }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './StepDescriptionMobilePlan.translations'

const i18n = useI18n()

const props = defineProps<{
  offers:
    | MobilePlanOffer[]
    | GetProductResponse['includedServiceOffers']['mobilePlans']
}>()

const offerWithFlashOffer = computed(() =>
  props.offers.find((offer) => Boolean(offer.baseOffer)),
)
</script>
